class PriceSlider extends HTMLElement {
    constructor() {
        super();
        this.sliderMinThumb = document.querySelectorAll('.sliderThumb')[0];
        this.sliderMaxThumb = document.querySelectorAll('.sliderThumb')[1];
        this.sliderRange = document.querySelector('.sliderRange');
        this.minInput = document.getElementById('price-input-min');
        this.maxInput = document.getElementById('price-input-max');
        this.minInputHidden = document.getElementById('price-input-min-hidden'); // hidden input for min
        this.maxInputHidden = document.getElementById('price-input-max-hidden'); // hidden input for max
        this.maxPrice = parseFloat(this.maxInput.placeholder.replace('$', ''));
        this.sliderContainer = document.querySelector('.sliderContainer');
    
        this.minInitialPosition = 0;
        this.maxInitialPosition = 100;

        const handleMin = this.onMouseMoveMin.bind(this);
        const handleMax = this.onMouseMoveMax.bind(this);

        const startDrag = (handler) => {
            return (e) => {
                if (e.type === "touchstart") {
                    e.preventDefault();
                    document.addEventListener('touchmove', handler);
                    document.addEventListener('touchend', onTouchEnd);
                } else if (e.type === "mousedown") {
                    document.addEventListener('mousemove', handler);
                    document.addEventListener('mouseup', onTouchEnd);
                }
            };
        };

        const onTouchEnd = () => {
            document.removeEventListener("mousemove", handleMin);
            document.removeEventListener("mousemove", handleMax);
            document.removeEventListener("mouseup", onTouchEnd);

            document.removeEventListener("touchmove", handleMin);
            document.removeEventListener("touchmove", handleMax);
            document.removeEventListener("touchend", onTouchEnd);
        };

        this.sliderMinThumb.addEventListener('mousedown', startDrag(handleMin));
        this.sliderMinThumb.addEventListener('touchstart', startDrag(handleMin));

        this.sliderMaxThumb.addEventListener('mousedown', startDrag(handleMax));
        this.sliderMaxThumb.addEventListener('touchstart', startDrag(handleMax));
    }
  

    setThumbPosition(thumb, position) {
        if (thumb.classList.contains("sliderThumb--left")) {
            thumb.style.left = position + "%";
        } else {
            thumb.style.right = (100 - position) + "%";
        }
    }
  
    setRangePosition(min, max) {
        this.sliderRange.style.left = min + '%';
        this.sliderRange.style.width = (max - min) + '%';
    }
  
    updateInputValues() {
        var minPercentage = parseFloat(this.sliderMinThumb.style.left);
        var maxPercentage = 100 - parseFloat(this.sliderMaxThumb.style.right);
        var minValue = (minPercentage / 100 * this.maxPrice).toFixed(0);
        var maxValue = (maxPercentage / 100 * this.maxPrice).toFixed(0);
        this.minInput.value = '$' + minValue + ".00";
        this.maxInput.value = "$" + maxValue + ".00";
        this.minInputHidden.value = minValue; // Update hidden input for min
        this.maxInputHidden.value = maxValue; // Update hidden input for max
    }

    onMouseMoveMin(e) {
        var clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
        var minPercentage = ((clientX - this.sliderContainer.getBoundingClientRect().left) / this.sliderContainer.offsetWidth) * 100;
        var maxPercentage = 100 - parseFloat(this.sliderMaxThumb.style.right);

        minPercentage = Math.min(Math.max(0, minPercentage), maxPercentage - 9);  // Restrict minPercentage to be at most 3.4% less than maxPercentage

        this.setThumbPosition(this.sliderMinThumb, minPercentage);
        this.setRangePosition(minPercentage, maxPercentage);
        this.updateInputValues();
    }

    onMouseMoveMax(e) {
        var clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
        var maxPercentage = ((clientX - this.sliderContainer.getBoundingClientRect().left) / this.sliderContainer.offsetWidth) * 100;
        var minPercentage = parseFloat(this.sliderMinThumb.style.left);

        maxPercentage = Math.min(Math.max(minPercentage + 9, maxPercentage), 100);  // Restrict maxPercentage to be at least 3.4% more than minPercentage

        this.setThumbPosition(this.sliderMaxThumb, maxPercentage);
        this.setRangePosition(minPercentage, maxPercentage);
        this.updateInputValues();
    }
};

customElements.define("price-slider", PriceSlider);
